import {
	liaoData
} from '../../views/config/res.js'
const sumUnread = (list = []) => {
	return list.reduce((sum, item) => {
		return sum + Number(item.message_unread_num || 0)
	}, 0)
}
export default {
	namespaced: true,

	state: {
		// 连接状态
		lineStatus: 'offline',
		liaoStatus: 'buyerOnlines',
		reconnectCount: 0,
		maxReconnect: 3,

		// 客服 / 用户数据
		// buylist:[],
		buyerOnlines: [],
		buyerHistories: [],
		buyerWaitings: [],
		specificChatMessage: [],
		user_offline: [],
		liaoData: liaoData,

		// UI 辅助状态（不直接操作 UI）
		scrollType: '',
		isMoreList: true,
		last_id: null,
		// message_num: 0,
		message_unread_num: 0,

		buyerOnlines_unread_num: 0,
		buyerWaitings_unread_num: 0,
		buyerHistories_unread_num: 0,

		// 客服相关
		changeKefuList: [],
		transferAdminList: '',
		isChatingId: null,

		// 事件通知（给组件用）
		notifyMessage: '',
		playVoice: 0,
		shake: false,
		lastVoiceTime: 0,

		// 当前客服 id（登录后注入）
		adminCustomerServiceId: null
	},

	mutations: {
		/* ----------------- 基础 ----------------- */
		SET_LINE_STATUS(state, status) {
			state.lineStatus = status
		},
		SET_LIAO_STATUS(state, status) {
			state.liaoStatus = status
		},
		INC_RECONNECT(state) {
			state.reconnectCount++
		},
		RESET_RECONNECT(state) {
			state.reconnectCount = 0
		},
		SET_ADMIN_ID(state, id) {
			state.adminCustomerServiceId = id
		},
		SET_CHAT_ID(state, id) {
			state.isChatingId = id
		},
		// SET_MESSAGE_NUM(state, val) {
		// 	state.message_num = val
		// },

		/* ----------------- 初始化 ----------------- */
		SET_INIT_DATA(state, data) {
			state.buylist = data
			state.buyerHistories = data.histories || []
			state.buyerOnlines = data.onlines || []
			state.buyerWaitings = data.waitings || []

			//2026/7/7要求只要取在线的
			state.message_unread_num = sumUnread(state.buyerOnlines)

			state.buyerOnlines_unread_num = sumUnread(state.buyerOnlines)
			state.buyerWaitings_unread_num = sumUnread(state.buyerWaitings)
			state.buyerHistories_unread_num = sumUnread(state.buyerHistories)


			// state.message_unread_num =
			// 	sumUnread(state.buyerHistories) +
			// 	sumUnread(state.buyerOnlines) +
			// 	sumUnread(state.buyerWaitings)
		},


		/* ----------------- 客服列表 ----------------- */
		SET_CHANGE_KEFU_LIST(state, list) {
			state.changeKefuList = (list || []).filter(
				i => i.id !== state.adminCustomerServiceId
			)
		},

		/* ----------------- 用户状态 ----------------- */
		USER_ONLINE(state, data) {
			state.user_offline = state.user_offline.filter(
				id => id !== data.session_id
			)
			state.buyerHistories.forEach(h => {
				if (h.session_id === data.session_id) {
					h.customer_service = data.customer_service
					h.status = 1
				}
			})
		},

		USER_OFFLINE(state, data) {
			if (!state.user_offline.includes(data.session_id)) {
				state.user_offline.push(data.session_id)
			}
			state.buyerHistories.forEach(h => {
				if (h.session_id === data.session_id) {
					h.customer_service = null
					h.status = 0
				}
			})
		},

		/* ----------------- 会话列表 ----------------- */
		REMOVE_WAITING(state, sessionId) {
			state.buyerWaitings = state.buyerWaitings.filter(
				i => i.session_id !== sessionId
			)
		},

		REMOVE_ONLINE(state, sessionId) {
			state.buyerOnlines = state.buyerOnlines.filter(
				i => i.session_id !== sessionId
			)
		},

		ADD_ONLINE(state, user) {
			state.buyerOnlines = [...state.buyerOnlines, {
				...user
			}]
		},

		// UPDATE_LAST_MESSAGE(state, {
		// 	session_id,
		// 	message
		// }) {
		// 	let found = false
		// 	state.buyerOnlines.forEach(i => {
		// 		if (i.session_id === session_id) {
		// 			i.last_message = message
		// 			found = true
		// 		}
		// 	})
		// 	return found
		// },

		UPDATE_LAST_MESSAGE(state, {
			session_id,
			message,
			dataType,
		}) {
			const item = state[dataType].find(
				k => k.session_id === session_id
			)

			if (item) {
				item.last_message = message
				return
			}
			

		},

		ADD_ONLINE_TOP(state, user) {
			state.buyerOnlines.unshift(user)
		},

		/* ----------------- 消息 ----------------- */
		ADD_MESSAGE(state, message) {
			state.specificChatMessage.push(message)
		},

		SET_MESSAGE_LIST(state, list) {
			state.specificChatMessage = list
		},

		/* ----------------- 其他 ----------------- */
		SET_SCROLL_TYPE(state, type) {
			state.scrollType = type
		},

		SET_NOTIFY(state, msg) {
			state.notifyMessage = msg
		},

		SET_VOICE(state) {
			const now = Date.now()
			if (now - state.lastVoiceTime < 3000) return

			state.lastVoiceTime = now
			state.playVoice = now // ✅ 每次都不一样
			// state.playVoice = val
		},

		SET_SHAKE(state, val) {
			state.shake = val
		},

		CLEAR_NOTIFY(state) {
			state.notifyMessage = ''
		},

		CLEAR_READ(state, CLEAR_READObj) {
			let message_unread_num = state[state.liaoData[CLEAR_READObj.groupIndex].type][CLEAR_READObj.index]
				.message_unread_num
			state[state.liaoData[CLEAR_READObj.groupIndex].type][CLEAR_READObj.index].message_unread_num = 0;
			state.message_unread_num = state.message_unread_num - message_unread_num
			state[state.liaoStatus + '_unread_num'] = state[state.liaoStatus + '_unread_num'] - message_unread_num
		},

		SPLICEBUYWAIT(state, index) {
			state.buyerWaitings.splice(index, 1);
		},

	},

	actions: {
		/* ==========================================================
		   WebSocket 消息总入口（你原来 onmessage 的 switch）
		   ========================================================== */
		handleSocketMessage({
			state,
			commit
		}, result) {
			if (!result.code) {
				commit('SET_NOTIFY', `错误响应：${result.msg}`)
				return
			}

			const data = result.data
			let scroll_type = {}

			switch (result.type) {
				case 'nologin':
					commit('SET_NOTIFY', '请先登录管理后台')
					break

				case 'no_customer_service':
					commit('SET_NOTIFY', '您还不是客服')
					break

				case 'init':
					commit('SET_INIT_DATA', data)
					state.user_offline = []
					data.histories.forEach(h => {
						if (h.status === 0) {
							state.user_offline.push(h.session_id)
						}
					})
					commit('SET_LINE_STATUS', 'online')
					commit('RESET_RECONNECT')
					break

				case 'customer_service_update':
					commit('SET_CHANGE_KEFU_LIST', data.customer_services)
					break

				case 'transfer_success':
					commit('REMOVE_ONLINE', data.session_id)
					state.transferAdminList = ''
					break

				case 'user_online':
					commit('USER_ONLINE', data)
					break

				case 'user_offline':
					commit('USER_OFFLINE', data)
					break

				case 'user_accessed':
					commit('REMOVE_WAITING', data.session_id)
					state.buyerHistories.forEach(h => {
						if (h.session_id === data.session_id) {
							h.customer_service = data.customer_service
							h.status = 1
						}
					})
					if (state.adminCustomerServiceId !== data.customer_service.id) {
						commit('REMOVE_ONLINE', data.session_id)
					}
					break

				case 'user_access': {
					commit('SET_VOICE', true)
					commit('REMOVE_WAITING', data.session_id)

					const exists = state.buyerOnlines.some(
						i => i.session_id === data.session_id
					)
					if (!exists) {
						commit('ADD_ONLINE', data.chat_user)
					}
					break;
				}

				case 'receipt':
					scroll_type = {
						type: 'receipt',
						t: Date.now()
					}
					commit('SET_SCROLL_TYPE', scroll_type)
					break

				case 'message': {
					commit('SET_VOICE', true)
					commit('SET_SHAKE', true)

					if (data.message.message_type === 'text') {
						data.message.message = window.replaceEmjio ?
							window.replaceEmjio(data.message.message) :
							data.message.message
					}

					if (
						data.message.message_type === 'goods' ||
						data.message.message_type === 'order'
					) {
						data.message.message = JSON.parse(data.message.message)
					}
					
					let isTrue = false 
					

					if (state.isChatingId === data.session_id) {
						isTrue = true
						state.specificChatMessage.push(data.message)
						commit('ADD_MESSAGE', data.message)

						//排队组和会话组轮番循环找到对应对话信息
						state.buyerOnlines.forEach(k => {
							if (k.session_id === data.session_id) {
								k.last_message = data.message.message
							}
						})
						state.buyerWaitings.forEach(k => {
							if (k.session_id === data.session_id) {
								k.last_message = data.message.message
							}
						})
					} else {
						//排队组和会话组轮番循环找到对应对话信息
						state.buyerOnlines.forEach(k => {
							if (k.session_id === data.session_id) {
								isTrue = true
								k.message_unread_num++;
								state.message_unread_num++;
								k.last_message = data.message
								state.buyerOnlines_unread_num++;
							}
						})
						state.buyerWaitings.forEach(k => {
							if (k.session_id === data.session_id) {
								isTrue = true
								k.message_unread_num++;
								state.message_unread_num++;
								k.last_message = data.message
								state.buyerWaitings_unread_num++;
							}
						})
						state.buyerHistories.forEach(k => {
							if (k.session_id === data.session_id) {
								isTrue = true
								k.message_unread_num++;
								state.message_unread_num++;
								k.last_message = data.message
								state.buyerHistories_unread_num++;
							}
						})
					}
					
					if(!isTrue){
						// 不存在就直接插
						state.buyerOnlines.unshift({
							...data.message,
							last_message: data.message,
							message_unread_num: 1,
							status: 1
						})
						state.buyerOnlines_unread_num++
						state.message_unread_num++
					}

					commit('UPDATE_LAST_MESSAGE', {
						session_id: data.session_id,
						message: data.message,
						dataType: state.liaoStatus,
					})

					// state[state.liaoStatus + '_unread_num'] = sumUnread(state[state.liaoStatus])

					// if (!found) {
					// 	commit('ADD_ONLINE_TOP', {
					// 		...data.message.identify,
					// 		last_message: data.message,
					// 		message_unread_num: 1,
					// 		status: 1
					// 	})
					// }

					scroll_type = {
						type: 'message',
						t: Date.now()
					}
					commit('SET_SCROLL_TYPE', scroll_type)
					break
				}



				case 'message_list':
					data.message_list.data.forEach(i => {
						if (i.message_type === 'text') {
							i.message = window.replaceEmjio ?
								window.replaceEmjio(i.message) :
								i.message
						}
						if (
							i.message_type === 'goods' ||
							i.message_type === 'order'
						) {
							i.message = JSON.parse(i.message)
						}
					})

					if (data.message_list.data.length > 0) {
						state.last_id = data.message_list.data[0].id
					}

					// state.message_num = data.message_list.data.length

					commit(
						'SET_MESSAGE_LIST',
						data.message_list.data.reverse().concat(state.specificChatMessage)
					)
					state.isMoreList = true
					scroll_type = {
						type: 'message_list',
						t: Date.now()
					}
					commit('SET_SCROLL_TYPE', scroll_type)
					commit('SET_SHAKE', false)
					break

				case 'del_success':
					commit('REMOVE_ONLINE', data.session_id)
					state.isChatingId = null
					break

				case 'switch_ok':
					commit('SET_LINE_STATUS', data.status)
					break
			}
		},
		// getIndex({ state,commit }, session_id){
		// },
		// maybePlayVoice({
		// 	state,
		// 	commit
		// }) {
		// 	const now = Date.now()
		// 	if (now - state.lastVoiceTime > 3000) {
		// 		commit('SET_VOICE', true)
		// 		state.lastVoiceTime = now
		// 	}
		// },
	}
}